module.exports = __webpack_public_path__ + "static/img/04hen.521c7072.gif";